import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import { M_Table, BufferService } from 'src/M_Components'

const ApproveBLNAIP = ({ roles, onCreateTab, toastMessages, tablesOrder = [], onTablesOrderUpdate }) => {
    const navigate = useNavigate()
    const { t } = useTranslation()
    const [waiting, setWaiting] = useState('')
    const [waiting2, setWaiting2] = useState('')
    const [waiting3, setWaiting3] = useState('')
    const [waiting4, setWaiting4] = useState('')

    const statusService = new BufferService('processStatus')

    useEffect(() => {
        statusService.get().then(res => {
            if (res.name === 'AxiosError') {
                toastMessages('error', res.message, '')
                return
            }
            res.Items.forEach(obj => {
                if (obj.StatusName === 'Waiting for Approval') {
                    setWaiting(obj.Id)
                }
                if (obj.StatusName === 'Waiting for Approval (Changes)') {
                    setWaiting2(obj.Id)
                }
                if (obj.StatusName === 'Waiting for Approval (Cancel)') {
                    setWaiting3(obj.Id)
                }
                if(obj.StatusName === 'Rejected by Transporter') {
                    setWaiting4(obj.Id)
                }
            })
        })
    }, [])

    const NewRoute = (url, label) => {
        let tempData = sessionStorage.getItem('lines')

        if (tempData === 'undefined' || tempData === null || tempData === undefined) {
            toastMessages('error', '', t("SelectedLine"))
            return
        }
        tempData = JSON.parse(tempData).pop()
        sessionStorage.removeItem('lines')
        sessionStorage.setItem('blContext', JSON.stringify(tempData))
        sessionStorage.setItem('operation', 'Approve')
        navigate(`${url}`)
        onCreateTab(url, label + " " + tempData?.NrBooking)
    }

    const NewRouteContext = (url, label) => {
        const tempData = sessionStorage.getItem('context')
        if (tempData === 'undefined') {
            toastMessages('error', '', t("SelectedLine"))
            return
        }
        sessionStorage.removeItem('context')
        sessionStorage.setItem('blContext', tempData)
        sessionStorage.setItem('operation', 'Approve')
        const newTempData = JSON.parse(tempData)
        navigate(`${url}`)
        onCreateTab(url, label + " " + newTempData?.NrBooking)
    }

    const lineContextMenuBL = [
        { label: t('CheckBL'), icon: 'pi pi-search', command: () => NewRouteContext("go/createBL", "Check BL") },
    ]

    const buttons = [
        { label: t('CheckBL'), element: 'default', source: '/icons/svgsDaNet/search.svg', style: { filter: 'invert(60%) sepia(93%) saturate(1397%) hue-rotate(169deg) brightness(83%) contrast(86%)' }, command: () => NewRoute("go/createBL", "Check BL") }
    ]

    const removeContextItems = ['View', 'Create', 'Edit', 'Print']

    const getLineBl = (e) => {
        if (e.length) {
            sessionStorage.setItem('lines', JSON.stringify(e))
        } else {
            sessionStorage.removeItem('lines')
        }
    }

    const getContextBl = (e) => {
        if (e) {
            sessionStorage.setItem('context', JSON.stringify(e))
        } else {
            sessionStorage.removeItem('context')
        }
    }

    return (
        waiting ?
            <M_Table
                entityName={'bl'}
                rolePermissions={roles}
                tablesOrder={tablesOrder}
                onTablesOrderUpdate={onTablesOrderUpdate}
                pageUrl={'Approve BLs'}
                lineContext={lineContextMenuBL}
                removeContextItems={removeContextItems}
                extraButtons={buttons}
                onPassLine={getLineBl}
                onPassContext={getContextBl}
                FILTER={`(IdProcessStatus eq ${waiting} or IdProcessStatus eq ${waiting2} or IdProcessStatus eq ${waiting3} or IdProcessStatus eq ${waiting4})&orderby=createdOnWithHours asc`}
            /> : ''
    )
}

export default ApproveBLNAIP